module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('headerTop'), _vm._v(" "), _c('div', {
    staticClass: "swiperImg",
    style: ({
      backgroundImage: 'url(' + _vm.$index.addurl(_vm.img) + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "center page-content",
    style: ({
      animation: _vm.animation
    })
  }, [_c('div', {
    staticClass: "child",
    domProps: {
      "innerHTML": _vm._s(_vm.contents)
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97b1dab8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/jrService/gcJieshao.vue
// module id = 1109
// module chunks = 1